import GlobalTable from '@/components/probaworkflows_base_components/GlobalTable/GlobalTable.vue';
import AICampusFooter from '@/components/probaworkflows_base_components/AICampusFooter/AiFooter.vue';

export default{
    name: 'Invoicing',
    components: {
        GlobalTable , AICampusFooter
        },
    data: () => ({
        selected_status: '',
        status_cards: [
          { title: 'Pending payment',color_class: 'text-danger', type: 'pending payment', icon: 'fa-regular fa-hourglass-half'},
          { title: 'Partially paid',color_class: 'orange-text',type: 'partially paid',icon: 'fas fa-credit-card' },
          { title: 'Paid',color_class: 'green-text',type: 'paid',icon: 'fa-solid fa-check-double' }
        ],
        
        trust_application_data: [
          { 
            application_no: 1, 
            founder_name: "John Doe", 
            trust_name: "Trust A", 
            date_started: "2024-01-01", 
            date_modified: "2024-02-01", 
            status: "partially paid", 
          },

          { 
            application_no: 2, 
            founder_name: "Jane Smith", 
            trust_name: "Trust B", 
            date_started: "2024-01-05", 
            date_modified: "2024-02-10", 
            status: "partially paid"
           },
          { 
            application_no: 3, 
            founder_name: "Mike Johnson", 
            trust_name: "Trust C", 
            date_started: "2024-02-01", 
            date_modified: "2024-02-20", 
            status: "paid" 
          }
        ]
    }),

    computed: {
        get_count() {
          return (status) => this.trust_application_data.filter(app => app.status === status).length;
        }
      },
}